import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom';
import { getRelaunchById, updateRelaunch } from '../../../services/Api/partnerService';
import { useRelaunchStore } from '../../../stores/admin/relauch';
import { useServiceStore } from '../../../stores/admin/service';
import { showToastError } from '../../../services/Toasts/toasts';

const UpdateRelaunch = ({ id, closeModal }: any) => {
  const { idPartner } = useParams();
  const { type, setType, days, setDays, text, setText, reset } = useRelaunchStore();
  const { update, setUpdate } = useServiceStore();

  useEffect(() => {
    getRelaunchById(Number(idPartner), Number(id))
      .then((res) => {
        setType(res.data.title);
        setDays(res.data.amountOfDays);
        setText(res.data.text);
      })
      .catch(() => showToastError("Une erreur s'est produite"));
  }, [id]);

  const handleUpdateRelaunch = () => {
    updateRelaunch(Number(idPartner), Number(id), { title: type, amountOfDays: days, text: text })
      .then(() => {
        setUpdate(!update);
        reset();
        closeModal();
      })
      .catch(() => showToastError("Une erreur s'est produite"));
  }

  return (    <>
    <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-hidden focus:outline-hidden">
      <div className="relative w-auto md:w-1/4 my-6 mx-auto max-w-3xl min-w-[45%]">
        {/* Content */}
        <div className="border-0 rounded-xl shadow-lg relative flex flex-col w-full bg-white outline-hidden focus:outline-hidden">
          {/* Header */}
          <div className="w-full bg-white p-3 rounded-t-xl">
            <h4 className="text-xl font-semibold text-gray-700 mb-3 flex items-center gap-2">
              <svg className="w-5 h-6 text-yellow-trio" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
              </svg>
              Modifier une relance
            </h4>
          </div>
          {/* Body */}
          <div className="w-full flex flex-col items-center justify-center text-grey-trio">
            <div className="flex flex-col justify-start items-start w-11/12 mb-6">
              <div className='flex flex-row justify-between items-center w-full gap-4'>
                <div className="w-full mb-4">
                  <label
                    htmlFor="title"
                    className="text-md sm:text-lg my-2 block text-gray-700 font-medium"
                    >
                    Titre :
                  </label>
                  <input
                    type="text"
                    value={type}
                    className="border border-gray-300 rounded-lg w-full h-12 p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent shadow-sm transition-all duration-200"
                    onChange={(e) => setType(e.target.value)}
                    minLength={2}
                    maxLength={200}
                    name="title"
                    id="title"
                    placeholder="ex: Relance urgente"
                    required
                    />
                </div>
                <div className="w-full mb-4">
                  <label
                    htmlFor="type"
                    className="text-md sm:text-lg my-2 block text-gray-700 font-medium"
                    >
                    Nombre de jours :
                  </label>
                  <input
                    type="number"
                    value={days}
                    className="border border-gray-300 rounded-lg w-full h-12 p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent shadow-sm transition-all duration-200"
                    onChange={(e) => setDays(parseInt(e.target.value))}
                    minLength={2}
                    maxLength={200}
                    name="amountOfDays"
                    id="amountOfDays"
                    placeholder="Entrez le nombre de jours"
                    required
                    />
                </div>
              </div>
              
              <div className="w-full mb-4">
                <label
                  htmlFor="text"
                  className="text-md sm:text-lg my-2 block text-gray-700 font-medium"
                >
                  Texte :
                </label>
                <textarea
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                  className="border border-gray-300 rounded-lg w-full h-28 p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent shadow-sm transition-all duration-200"
                  required
                />
              </div>

              <div className="w-full bg-blue-50 border border-blue-200 rounded-lg p-4">
                <div className="flex items-start gap-3">
                  <svg className="w-5 h-5 text-blue-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <div>
                    <p className="text-sm text-blue-800 font-medium mb-1">Information</p>
                    <p className="text-sm text-blue-700">
                      L'utilisateur recevra un email de relance avec le texte saisi ci-dessus.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="flex items-center justify-end p-3 rounded-b-2xl bg-white gap-3">
            <button
              className="px-4 py-2 bg-gray-100 text-gray-500 hover:bg-red-500 hover:text-white cursor-pointer font-semibold rounded-xl transition-all duration-200 flex items-center gap-2 text-sm"
              type="button"
              onClick={() => {
                closeModal();
              }}
            >
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
              Annuler
            </button>
            <button
              className="px-4 py-2 bg-green-600 hover:bg-green-700 cursor-pointer text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center gap-2 text-sm"
              type="button"
              onClick={() => {
                handleUpdateRelaunch();
              }}
            >
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
              </svg>
              Créer
            </button>
          </div>
        </div>
      </div>
    </div>
    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
  </>
  )
}

export default UpdateRelaunch
